import React from "react";
import { Link } from "react-router-dom";
import { FaHeadset, FaChartLine, FaHandsHelping } from "react-icons/fa";
import "./SupportModelSection.css";

const SupportModelSection = () => {
    return (
        <section className="_sMSec_z1A_">
            <div className="_sMCont_a2B_">
                <h2 className="_hTitle_s5E_ features-title">
                    Our Support Model: Reliable, Transparent, Human
                </h2>
                <div className="features-grid_23">

                    {/* Multi-Channel Helpdesk */}
                    <div className="feature-item add-padding-top">
                        <div className="feature-icon">
                            <FaHeadset />
                        </div>
                        <h4 className="feature-title-text">Multi-Channel Helpdesk</h4>
                        <ul className="_sCList_i9I_">
                            <li>
                                <strong>24×7 ticket-based support</strong> (web, app, email, WhatsApp)
                            </li>
                            <li>Real-time status and easy case tracking</li>
                            <li>Clear escalation paths for urgent cases</li>
                            <li>Comprehensive self-help and FAQ center</li>
                        </ul>
                    </div>

                    {/* SLAs & Transparency */}
                    <div className="feature-item add-padding-top">
                        <div className="feature-icon">
                            <FaChartLine />
                        </div>
                        <h4 className="feature-title-text">SLAs & Transparency</h4>
                        <ul className="_sCList_i9I_">
                            <li>
                                <strong>Acknowledgment in 10 minutes</strong>, first response within 2 hours
                            </li>
                            <li>Dispute categories and escalation paths published for all users</li>
                            <li>Monthly SLA performance reports available for review</li>
                        </ul>
                    </div>

                    {/* Dedicated & Volunteer Support */}
                    <div className="feature-item add-padding-top">
                        <div className="feature-icon">
                            <FaHandsHelping />
                        </div>
                        <h4 className="feature-title-text">
                            Dedicated & Volunteer Support
                        </h4>
                        <ul className="_sCList_i9I_">
                            <li>Trained volunteers handle simple queries and first response</li>
                            <li>Escalation to managers for complex or critical cases</li>
                            <li>Support handbook and clear contacts for all escalation levels</li>
                            <li>
                                See our{" "}
                                <Link to="/support" className="_sLink_j0J_">
                                    full support details
                                </Link>
                                .
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default SupportModelSection;